import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL;

class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'auth/gesbeques/login', {
        nif: user.nif,
        password: user.password
      })
      .then(response => {
        if (response.data.data.access_token) {
          localStorage.setItem('user', JSON.stringify(response.data.data));
        }

        return response.data.data;
      });
  }
  async checkAuth() {
    try {
        const res = await axios.post(API_URL + 'auth/gesbeques/autologin', {}, { headers: authHeader() });
        return res
    } catch (error) {
        if(error.response.status == 401){
            localStorage.removeItem('user')
            location.href = '/login'
        }
        return error.response
    }
}



  logout() {
    localStorage.removeItem('user');
  }
}

export default new AuthService();